import { render, staticRenderFns } from "./estoques.vue?vue&type=template&id=75b08590&"
import script from "./estoques.vue?vue&type=script&lang=js&"
export * from "./estoques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports